/* eslint-disable */
import { useRef, useState, useEffect, useContext } from "react";
import AuthContext from "../../../../context/AuthProvider";
import axios from "axios";
import Cookies from "js-cookie";
import * as Icon from "react-bootstrap-icons";
import "./Login.css";
import Toast from "../../../assetLibComponents/shared/Toast";
import { useNavigate, useParams } from "react-router-dom";

//Redux-imports
import { useDispatch, useSelector } from "react-redux";

const SignUpComponent = (props) => {
    const dispatch = useDispatch();
    const params = new URLSearchParams(window.location.search);
    const urlSource = params.get('source');
    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [compName, setCompName] = useState("");    
    const [compWebsite, setCompWebsite] = useState("");
    const [email, setEmail] = useState("");
    const [passwordCheck, setPasswordCheck] = useState(false);
    const [termsCheck, setTermsCheck] = useState(false);
    const [firstPassword, setFirstPassword] = useState("");
    const authCtx = useContext(AuthContext);
    const SIGN_UP_URL = authCtx.signupUrl;
    const [showPassword, setShowPassword] = useState("");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [userExist, setUserExist] = useState(false);
    const [verifyMail, setVerifyMail] = useState(false);
    const [authToken, setAuthToken] = useState("");
    const { userEmail, websiteUrl } = useParams();

    useEffect(()=>{
        if(userEmail?.length>0){
            setEmail(userEmail);
        }
        if(websiteUrl?.length>0){
            setCompWebsite(websiteUrl);
        }
        if (urlSource !== null) {
            Cookies.set("source",urlSource);
        }
    },[])


    // const checkValidation = () => {       
    //     if (name === "") {
    //         Toast("Please fill the first name", "E");
    //     } else if (lastName === "") {
    //         Toast("Please fill the last name", "E");
    //     } else if (compName === "") {
    //         Toast("Please fill the company name", "E");
    //     } else if (compWebsite === "") {
    //         Toast("Please fill the company website", "E");
    //     } else if (email === "") {
    //         Toast("Please fill the email", "E");
    //     } else if (firstPassword === "") {
    //         Toast("Please fill the password", "E");
    //     }  else {
    //         return;
    //     }
    // }
    const checkValidation = () => {       
         if (compWebsite === "") {
            Toast("Please fill the company website", "E");
        } else if (email === "") {
            Toast("Please fill the email", "E");
        }  else {
            return;
        }
    }
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (name === "" || lastName === "" || compName === "" || compWebsite === "" || email === "" || firstPassword === "") {
        if (compWebsite === "" || email === "") {
            checkValidation();
            return;
        }
        if (compWebsite !== "") {
            if (!compWebsite.includes(".")) {
                Toast("Please enter the valid company website", "E");
                return;
            }
        }
        if (email !== "") {
            const officialDomains = [
                "gmail.com",
                "yahoo.com",
                "rediff.com",
                "yopmail.com",
                "outlook.com",
            ];
            const enteredDomain = email.split("@")[1];
            const isOfficial = officialDomains.includes(enteredDomain?.toLowerCase());
            const emailRegex = /^[A-Z0-9._%+-]+@([A-Z0-9.-]+\.)+[A-Z]{2,}$/i;
            const isEmailValid = emailRegex.test(email);
            if (isOfficial === true || isEmailValid === false) {
                Toast("Please enter the valid email", "E");
                return;
            }
        }
        // if (passwordCheck === true) {
        //     return;
        // }
        if (termsCheck === false) {
            Toast("Please accept the Terms of Service and Privacy Policy.", "E");
            return;
        }
        setButtonLoader(true);
        try {
          const response = await axios.post(SIGN_UP_URL, {
            email:email,
            // password:firstPassword,
            // confirm_password:firstPassword,
            // first_name:name,
            // last_name:lastName,
            // company_name:compName,
            source:Cookies.get("source") || null,
            domain:compWebsite,
            // company_logo:""
          });
          if (response?.data?.statusCode === "401") {
            Toast(response?.data?.response, "E");
            setButtonLoader(false);
          } else if (response?.data?.statusCode === "400") {
            Toast(response?.data?.response, "E");
            setButtonLoader(false);
          } else if (response?.data?.statusCode === "202") {
            Toast(response?.data?.response, "E");
            setButtonLoader(false);
          } else if (response?.data?.statusCode === "200") {
            if(response?.data?.message == "User Registered Successfully"){
                setVerifyMail(true);
                setUserExist(false);
                Cookies.set("source","null");
            }else if(response?.data?.message == "User Already Exists"){
                setUserExist(true);
                setVerifyMail(false);
            }
            const randomId = Math.floor(Math.random() * 900000) + 100000;
            const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
            Cookies.set("chatid", `backend-${randomId}`, { expires: expiryDate });
            setButtonLoader(false);
            setName("");
            setLastName("");
            setCompName("");
            setCompWebsite("");
            setEmail("");
            setFirstPassword("");
          } else {
            Toast(response?.data?.message, "E");
          }
        } catch (err) {
          setButtonLoader(false);
          console.log("ERR",err);
        }
    };

    useEffect(() => {
        setAuthToken(authCtx.auth);
    }, [setAuthToken, authCtx.auth, authToken]);

    let navigate = useNavigate();

    const title = props.title;
    useEffect(() => {
        document.title = `Get Started with Zoi | ${title}`;
        window.scrollTo(0, 0);
            // if (!localStorage.getItem("userData")) {
        //   navigate("/");
        // }
    }, [title, navigate]);

    // useEffect(() => {
    //     // Get the current URL
    //     const currentURL = window.location.href;

    //     // Create a URL object to parse the URL
    //     const url = new URL(currentURL);

    //     // Get the "code" query parameter value
    //     const eCode = url.searchParams.get('code');

    //     if (eCode) {
    //         // Do something with the extracted "code" value
    //         console.log('Extracted code:', eCode);
    //         dispatch(getCalendlyToken(props.authToken, eCode));
    //         navigate("/Setting/calendly")
    //         // You can now use the "code" in your React component's state or perform any desired actions.
    //     } else {
    //         console.log('No code parameter found in the URL');
    //     }

    //     // Cleanup: Set isMounted to false when the component unmounts
    // }, []);

    return (
        <div className="mt-2 max-sm:mt-2">
            <div>
                <form action="#" method="POST" className="space-y-4 max-sm:space-y-4">
                    {/* <div className="flex">
                        <div className="relative pr-1">
                            <label
                                htmlFor="name"
                                className="block text-sm font-medium leading-6 text-gray-900"
                            >
                            First Name
                            </label>
                            <input
                                type="text"
                                name="name"
                                id="name"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                placeholder=""
                                value={name}
                                onChange={(e) => { setName(e.target.value); }}                          
                            />
                        </div>
                        
                        <div className="relative pl-1">
                            <label
                                htmlFor="name"
                                className="block text-sm font-medium leading-6 text-gray-900"
                            >
                                Last Name
                            </label>
                            <input
                                type="text"
                                name="name"
                                id="name"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                                placeholder=""
                                value={lastName}
                                onChange={(e) => { setLastName(e.target.value); }}                          
                            />
                        </div>
                    </div>

                    <div className="relative">
                        <label
                            htmlFor="name"
                            className="block text-sm font-medium leading-6 text-gray-900"
                        >
                            Company Name
                        </label>
                        <input
                            type="text"
                            name="name"
                            id="name"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                            placeholder=""
                            value={compName}
                            onChange={(e) => { setCompName(e.target.value); }} 
                        />
                    </div> */}
                            
                    <div className="relative">
                        <label
                            htmlFor="name"
                            className="block text-sm font-medium leading-6 text-gray-900"
                        >
                            Company Website
                        </label>
                        <input
                            type="text"
                            name="name"
                            id="name"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                            placeholder=""
                            value={compWebsite}
                            onChange={(e) => { setCompWebsite(e.target.value); }} 
                        />
                    </div>


                    <div className="relative">
                        <label
                            htmlFor="name"
                            className="block text-sm font-medium leading-6 text-gray-900"
                        >
                            Official Email
                        </label>
                        <input
                            type="text"
                            name="name"
                            id="name"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                            placeholder=""
                            value={email}
                            onChange={(e) => { setEmail(e.target.value); }} 
                        />
                    </div>
                            
                    {/* <div className="relative">
                        <label
                            htmlFor="name"
                            className="block text-sm font-medium leading-6 text-gray-900"
                        >
                            Password 
                        </label>
                        <input
                            type={showPassword !== true ? "password":"text"}
                            name="name"
                            id="name"
                            className={"block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"+(passwordCheck === true ? " focus:ring-red-700 ":" focus:ring-[var(--brand-primary)] ")}
                            placeholder=""
                            value={firstPassword}
                            onChange={(e) => {
                                const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
                                if (regex.test(e.target.value) || e.target.value.length < 1 || e.target.value.length === null ) {
                                    setPasswordCheck(false);
                                } else {
                                    setPasswordCheck(true);
                                }
                                setFirstPassword(e.target.value);
                            }} 
                        />
                        { showPassword === true ? <Icon.Eye onClick={() => { setShowPassword(false); }} className="cursor-pointer absolute text-lg text-[var(--brand-primary)] right-[17px] top-[55%]"/> 
                            :
                            <Icon.EyeSlash onClick={() => { setShowPassword(true); }} className="cursor-pointer absolute text-lg text-gray-500 right-[17px] top-[55%]" />
                        }
                    </div> */}
                    {/* {passwordCheck === true && <p style={{margin:0}} className="text-red-700 text-[10px]">Password must be at least 8 characters long and include at least one letter, one number, and one special character.</p>}     */}
                    
                    <div className="relative">
                        <fieldset>
                            <div className="space-y-5">
                                <div className="relative flex items-start">
                                <div className="flex h-6 items-center">
                                    <input
                                    id="comments"
                                    aria-describedby="comments-description"
                                    name="comments"
                                    type="checkbox"
                                    checked={termsCheck}  
                                    onChange={(e) => {
                                        setTermsCheck(e.target.checked);
                                    }}                                            
                                    className="h-4 w-4 rounded border-gray-300 text-[var(--brand-primary)] focus:ring-[var(--brand-primary)]"
                                    />
                                </div>
                                <div className="ml-3 text-xs leading-6">
                                    <span id="comments-description" className="text-gray-800">
                                        I agree to Zoi's <a href="https://www.askzoi.ai/terms-and-conditions" className="font-bold hover:underline" target="blank">Terms of Service</a> and <a href="https://www.askzoi.ai/privacy-policy"  className="font-bold hover:underline" target="blank">Privacy Policy</a>.
                                    </span>
                                </div>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                                        
                    <div>
                        <button
                        onClick={handleSubmit}
                        type="submit"
                        className="h-[36px] flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                        >
                        {buttonLoader ? <div className="login-dual-ring"></div> : 'Submit'}
                        </button>
                    </div>
                    {verifyMail && <div id="successMsg" className="mb-1 text-green-500 text-sm font-bold text-center">We've sent you a verification mail!</div>}         
                    {userExist && <div className="mb-1 text-red-500 text-sm font-bold text-center">This Email is already registered!</div>}         
                    <p className="text-center text-sm text-gray-500">
                        Already have an account?{' '}
                        <span onClick={()=>{navigate("/")}} className="cursor-pointer font-semibold leading-6 text-[var(--brand-primary)] hover:text-indigo-500">
                        Sign in
                        </span>
                    </p>         
                </form>
            </div>
        </div>
    );
};

export default SignUpComponent;
